import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import *  as chatActions from '../../actions/chat';
import Header from './Header';
import Feed from './Feed';
import Form from './Form';
import UserList from './UserList';


function mapStateToProps(state) {
    return {
        chat: state.chat
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initChat: chatActions.initChat,
        userJoined: chatActions.userJoined,
        userLeft: chatActions.userLeft,
        newMessage: chatActions.newMessage,
        sendMessage: chatActions.sendMessage,
        toggleUserList: chatActions.toggleUserList
    }, dispatch)
}

class Chat extends Component {
    constructor(props){
        super(props);
        this.state = {
            text: ''
        }
        this.onChange = this.onChange.bind(this);
  //      this.onSend = this.onSend.bind(this);
    }
    componentWillMount(){

    }
    onChange(e){
        this.setState({text: e.target.value});
    }
    render(){
        const { messages, userList, showUserList } = this.props.chat;
        const { sendMessage } = this.props;
        return (
            <div className='fixed-right'>
                <Header onClick={this.props.toggleUserList}/>
                { showUserList ? <UserList userList={userList} /> : '' }
                <Feed messages={messages}/>
                <Form
                   text={this.state.text} 
                   onChange={this.onChange} 
                   onClick={ sendMessage(this.state.text)} 
                />
            </div>
        )
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Chat);


// WEBPACK FOOTER //
// ./src/components/chat/index.js